export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID as string,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage' as const,
    storeAuthStateInCookie: false,
  },
}

export const loginRequest = {
  scopes: ['User.Read'],
}

export const apiRequest = {
  // `profile`/`email` so the access token carries preferred_username/name —
  // needed to record who sent customer emails ("av" in the send log, #12357).
  scopes: [
    `api://${import.meta.env.VITE_ENTRA_CLIENT_ID}/access_as_user`,
    'openid',
    'profile',
    'email',
  ],
}
